var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"additional-services-booked"},_vm._l((_vm.additional_services),function(additional_service){return _c('content-section',{key:additional_service.type,attrs:{"title":_vm.capitalize_string(
        _vm.transcode_additional_services(additional_service.type, 99),
      )}},[(
        additional_service.type === 'CHECKED_BAGS' &&
        Object.keys(_vm.flexible_bags).length > 0
      )?[_c('booked-bags',{attrs:{"flight_offer":_vm.flight_offer,"flexible_bags":_vm.flexible_bags,"travelers":_vm.travelers}})]:(additional_service.type === 'SEATS')?[_c('booked-seats',{attrs:{"flight_offer":_vm.flight_offer,"travelers":_vm.travelers}})]:_vm._e()],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }